/**
 * Activity logging service - sends user activity to /activities/add
 * Use logActivity() to track user actions across all modules
 */
import { baseurl } from "../Components/Url";

const SESSION_KEY = "duno_activity_session";
const NODE_KEY = "duno_activity_node";

function getOrCreateSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

function getNode() {
  let node = sessionStorage.getItem(NODE_KEY);
  if (!node) {
    const ua = navigator.userAgent || "";
    const lang = navigator.language || "";
    node = `${ua.substring(0, 100)}|${lang}`;
    sessionStorage.setItem(NODE_KEY, node);
  }
  return node;
}

function getOsFromNode(node) {
  const raw = String(node || "").toLowerCase();
  if (!raw) return "unknown";
  if (raw.includes("windows")) return "Windows";
  if (raw.includes("android")) return "Android";
  if (raw.includes("iphone") || raw.includes("ipad") || raw.includes("ios")) return "iOS";
  if (raw.includes("mac os") || raw.includes("macintosh")) return "macOS";
  if (raw.includes("linux")) return "Linux";
  return "unknown";
}

function generateActivityId() {
  return `act_${Date.now()}_${Math.random().toString(36).slice(2, 15)}`;
}

/**
 * Log user activity to the backend
 * @param {Object} params
 * @param {string} params.module - Module name (e.g. DASHBOARD, MY_LEARNINGS, PROFILE, GOALS, etc.)
 * @param {string} params.action - Action type (e.g. PAGE_VISIT, CLICK, SUBMIT, NAVIGATE, etc.)
 * @param {string} [params.location] - Current path/URL
 * @param {string} [params.instance] - Specific instance (e.g. learning_id, topic_id, job_id)
 * @param {string} [params.remark] - Additional context
 */
export async function logActivity({ module, action, location, instance, remark }) {
  const token = localStorage.getItem("access-token");
  const userId = localStorage.getItem("USERID") || "anonymous";
  const node = getNode();

  const payload = {
    id: generateActivityId(),
    session_id: getOrCreateSessionId(),
    user_id: userId,
    node,
    os: getOsFromNode(node),
    location: location || (typeof window !== "undefined" ? window.location?.pathname : ""),
    module: module || "UNKNOWN",
    action: action || "UNKNOWN",
    instance: instance || "",
    remark: remark || "",
    action_on: new Date().toISOString(),
  };

  try {
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      try {
        const parsed = typeof token === "string" ? JSON.parse(token) : token;
        const bearer = parsed?.token ?? parsed;
        if (bearer) headers.Authorization = `Bearer ${bearer}`;
      } catch {
        headers.Authorization = `Bearer ${token}`;
      }
    }

    const res = await fetch(`${baseurl}/activities/add`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      console.warn("[Activity] Log failed:", res.status, await res.text());
    }
  } catch (err) {
    console.warn("[Activity] Log error:", err?.message);
  }
}
